export default __webpack_public_path__ + "static/media/project1.d554c912.png";